//console.log("lib inclusion: lazy-youtube-loader (.js)");

//YT Play Button (svg-Red)
var mtgf_yt_playButton =
    '<svg xmlns="http://www.w3.org/2000/svg" width="256" height="150" viewBox="0 0 256 150">\
    <rect x="8" y="8" width="240" height="134" rx="20" ry="20" fill="#FF0000"/>\
    <polygon points="98,47 98,103 166,75" fill="#FFFFFF"/>\
    </svg>';

//YT Re-play Button (svg-Red)  -- future enhancement
var mgt_yt_replayButton =
    '<svg xmlns="http://www.w3.org/2000/svg" width="256" height="150" viewBox="0 0 256 150">\
    <rect x="8" y="8" width="240" height="134" rx="20" ry="20" fill="#0066CC"/>\
    <text x="128" y="92" font-family="Arial,sans-serif" font-size="32" font-weight="bold" fill="#FFFFFF" text-anchor="middle">REPLAY</text>\
    </svg>';

//YT Offline Button (svg-Gray)
var mtgf_yt_videoOffline =
    '<svg xmlns="http://www.w3.org/2000/svg" width="256" height="150" viewBox="0 0 256 150">\
    <rect x="8" y="8" width="240" height="134" rx="20" ry="20" fill="#808080"/>\
    <text x="128" y="92" font-family="Arial,sans-serif" font-size="34" font-weight="bold" fill="#FFFFFF" text-anchor="middle">OFFLINE</text>\
    </svg>';

var mtgf_yt_playButtonUri = 'data:image/svg+xml;utf8,' + encodeURIComponent(mtgf_yt_playButton);
var mtgf_yt_videoOfflineUri = 'data:image/svg+xml;utf8,' + encodeURIComponent(mtgf_yt_videoOffline);

//Product page scenario - add TAB-click event so it can toggle [DESCRIPTION] / [SPECIFICATION] / [VIDEOS] / [WARRANTY]
function initProductTabEvents() {
    var tabs = document.querySelectorAll('.tab');
    var tabContents = document.querySelectorAll('.tab-content');
    tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
            try {
                const contentId = this.dataset.contentId || null;
                const mtgfElementId = this.id || null;
                const resolvedId =
                    (mtgfElementId && mtgfElementId.trim() !== "")
                 ? mtgfElementId.replace("mtgf-", "")
                 : (contentId && contentId.trim() !== ""
                     ? contentId
                     : null);
                if (!resolvedId) {
                    console.warn("No valid contentId or mtgfElementId found for tab:", this);
                    return;
                }

                const content = document.getElementById(resolvedId);

                if (!content) {
                    console.warn("Content element not found for ID:", resolvedId);
                    return;
                }
                tabContents.forEach(function (c) {
                    c.classList.remove('active');
                });

                tabs.forEach(function (t) {
                    t.classList.remove('active');
                });

                this.classList.add('active');
                content.classList.add('active');
            } catch (err) {
                console.error("Tab click handler failed:", err);
            }
        });
    });
}

function initYouTubeLazyLoader() {

    function createTransparentHQ() {
        var canvas = document.createElement("canvas");
        canvas.width = 480;
        canvas.height = 360;
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        return canvas.toDataURL("image/png");
    }

    var transparentFallback = createTransparentHQ();
    //var yt_items = document.querySelectorAll('.mtgf-yt-lazy');
    var yt_items = document.querySelectorAll('[id^="mtgf-yt-"]');

    function fetchYouTubeMeta(ytId, callback) {
        const url = "https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=" + ytId + "&format=json";

        fetch(url)
        .then(res => res.ok ? res.json() : null)
        .then(data => {
            if (data) {
                callback({
                    title: data.title || "",
                    author: data.author_name || ""
                });
            } else {
                callback({
                    title: "",
                    author: ""
                });
            }
        })
        .catch(() => callback({
                title: "",
                author: ""
            }));
    }

    function checkYouTubeThumb(url, callback) {
        var xhr = new XMLHttpRequest();

        try {
            xhr.open("HEAD", url, true);

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    callback(xhr.status === 200);
                }
            };

            xhr.send(null);

        } catch (e) {
            callback(false);
        }
    }

    function setupThumbnailAndPlayButton(el, ytId, imgSrc, isInvalid, meta) {
        try {

            var img = el.querySelector("img.mtgf-yt-thumb");
            if (!img) {
                img = document.createElement("img");
                img.className = "mtgf-yt-thumb";
                img.src = imgSrc;
                img.alt = isInvalid ? "Video no longer available" : "Video preview";
            }

            var overlay = document.createElement("div");
            overlay.className = "mtgf-yt-title-overlay";

            var titleLine = document.createElement("div");
            titleLine.className = "mtgf-yt-title-line";
            titleLine.textContent = meta.title || "";

            var authorLine = document.createElement("div");
            authorLine.className = "mtgf-yt-author-line";
            authorLine.textContent = meta.author || "";

            overlay.appendChild(titleLine);
            overlay.appendChild(authorLine);

            var playBlock = el.querySelector(".mtgf-yt-play-button");
            //if (!playBlock) {
            //    playBlock = document.createElement("div");
            //    playBlock.className = "mtgf-yt-play-button";
            //}
            if (!playBlock) {
                playBlock = document.createElement("IMG");
                playBlock.className = "mtgf-yt-play-button";
                playBlock.src = mtgf_yt_playButtonUri;
            }

            if (isInvalid) {
                playBlock = document.createElement("IMG");
                playBlock.className = "mtgf-yt-play-button-error";
                playBlock.src = mtgf_yt_videoOfflineUri;
            } else {

                //playBlock.innerHTML = "&nbsp;&nbsp;&#9654;&nbsp;&nbsp;";
                playBlock.className = "mtgf-yt-play-button";

                playBlock.onclick = function () {
                    try {
                        var iframe = document.createElement("iframe");

                        var w = el.offsetWidth;
                        var h = el.offsetHeight;

                        iframe.style.width = w + "px";
                        iframe.style.height = h + "px";

                        iframe.src = "https://www.youtube.com/embed/" + ytId + "?vq=large&autoplay=1&modestbranding=0&showinfo=0&cc_load_policy=0%rel=0&controls=1&enablejsapi=1";
                        iframe.frameBorder = "0";
                        iframe.allowFullscreen = true;
                        iframe.allow = "autoplay; encrypted-media";

                        iframe.setAttribute("mtgf-yt-embed-id", ytId);

                        el.innerHTML = "";
                        el.appendChild(iframe);

                    } catch (e) {
                        console.log("Iframe load failed:", e);
                    }
                };
            }

            el.innerHTML = "";
            el.style.position = "relative";
            el.appendChild(img);
            el.appendChild(overlay);
            el.appendChild(playBlock);

        } catch (e) {
            console.log("UI build failed:", e);
        }
    }

    // Enumerate & Initialize all Embedded YouTube Lazy Loader Div Elements found
    // Constructs with in DIV element
    //    * Video OffLine Disabled Button
    //    * Play Button
    //    * binds Click to Play Event
    for (var i = 0; i < yt_items.length; i++) {
        (function (el) {
            var elId = el.id || "";
            if (!elId)
                return;

            var ytId = elId.replace("mtgf-yt-", "");
            if (!ytId)
                return;

            if (!el.querySelector(`iframe[mtgf-yt-embed-id="${ytId}"]`)) {
                //console.log("initializing - " + ytId);
                if (el.querySelector(`iframe[mtgf-yt-embed-id="${ytId}"]`))
                    return;

                try {
                    var thumbUrl = "https://i.ytimg.com/vi/" + ytId + "/hqdefault.jpg";

                    checkYouTubeThumb(thumbUrl, function (isValid) {
                        var imgSrc = isValid ? thumbUrl : transparentFallback;

                        fetchYouTubeMeta(ytId, function (meta) {
                            setupThumbnailAndPlayButton(el, ytId, imgSrc, !isValid, meta);
                        });
                    });

                } catch (e) {
                    console.log("Block failed:", e);
                }
            } else {
                //Skip if iframe with SAME embed ID already exists
                console.log("already initialized - " + ytId);
            }
        })(yt_items[i]);
    }
}

function removeInnerVideoWrapperWhitespaces() {
    try {
        document.querySelectorAll('.mtgf-video-wrapper').forEach(wrapper => {
            Array.from(wrapper.childNodes).forEach(node => {
                // Target ONLY direct text nodes that consist purely of whitespace / &nbsp;
                if (node.nodeType === Node.TEXT_NODE && node.textContent.trim() === '') {
                    node.remove();
                }
            });
        });
    } catch (error) {
        //console.error("Error stripping whitespace nodes from .mtgf-video-wrapper:", error);
        //simply resume
    }
}

initProductTabEvents();
initYouTubeLazyLoader();
removeInnerVideoWrapperWhitespaces();
